<template>
  <div>
    <ServiceInfo></ServiceInfo>
  </div>
</template>

<script>
import ServiceInfo from "@/components/shoplus_authservice/service/ServiceInfo.vue";

export default {
  components: {
    ServiceInfo,
  },
};
</script>
